import general from './general';
import cs from './cs';

export default {
  ...general,
  ...cs,
};

export const placeholderGroups = {
  general,
  cs,
};
